module.exports = __webpack_public_path__ + "853fff36b473d87ec30f1dc99632c2ca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-13.png
// module id = 1627
// module chunks = 0